import { getCookie } from "@jti/fe-common";
import { BrowserStorage, User } from "./../";
const COOKIE_NAME = "session_refresh_token";
const USER_KEY = "user";
const TOKEN_KEY = "ciam_token";
const COOKIE_SYNC_INIT_KEY = "cookie_sync_initialized";
const isValidToken = (value) => typeof value === "string" && value.length > 0;
const isCookieSyncInitialized = () => sessionStorage.getItem(COOKIE_SYNC_INIT_KEY) === "true";
const setCookieSyncInitialized = () => {
    sessionStorage.setItem(COOKIE_SYNC_INIT_KEY, "true");
};
export const syncCookieToLocalStorage = () => {
    var _a;
    const cookieValue = getCookie(COOKIE_NAME);
    if (!cookieValue || !isValidToken(cookieValue))
        return;
    try {
        const userData = JSON.parse((_a = localStorage.getItem(USER_KEY)) !== null && _a !== void 0 ? _a : "{}");
        if (!userData[TOKEN_KEY] || userData[TOKEN_KEY] === cookieValue)
            return;
        new User(new BrowserStorage()).setUser({ [TOKEN_KEY]: cookieValue });
    }
    catch (error) {
        console.error("Failed to sync cookie to localStorage:", error);
    }
};
export const initCookieSync = () => {
    if (window.cookieStore && !isCookieSyncInitialized()) {
        window.cookieStore.addEventListener("change", (event) => {
            var _a;
            if ((_a = event.changed) === null || _a === void 0 ? void 0 : _a.some((cookie) => cookie.name === COOKIE_NAME)) {
                syncCookieToLocalStorage();
            }
        });
        setCookieSyncInitialized();
    }
};
// Test helper function to reset initialization state
export const resetCookieSyncState = () => {
    sessionStorage.removeItem(COOKIE_SYNC_INIT_KEY);
};
//# sourceMappingURL=cookieSync.js.map